import { render, staticRenderFns } from "./DataTableItemKeyValue.vue?vue&type=template&id=15e8ac1e&scoped=true&"
import script from "./DataTableItemKeyValue.vue?vue&type=script&lang=ts&"
export * from "./DataTableItemKeyValue.vue?vue&type=script&lang=ts&"
import style0 from "./DataTableItemKeyValue.vue?vue&type=style&index=0&id=15e8ac1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8ac1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
